import type {
  InspectBucketDayRow,
  SegmentHttpRow,
  SegmentIndexRow,
} from '../api/types';
import type { StatsRange } from './job-range';
import { dayKeysForRange, tehranDayLabel } from './overview-stats';
import { decodeUrlForDisplay } from './utils';

export type AdvancedStatsRange = StatsRange;

export function advancedStatsDays(range: StatsRange): AdvancedStatsRange {
  return range;
}

export function evolutionPct(
  current: number,
  previous: number,
): number | null {
  if (previous === 0) {
    if (current === 0) return 0;
    return null;
  }
  return Math.round(((current - previous) / previous) * 1000) / 10;
}

export function evolutionTone(
  current: number,
  previous: number,
  invert = false,
): 'success' | 'danger' | 'neutral' {
  const delta = current - previous;
  if (delta === 0) return 'neutral';
  const positive = delta > 0;
  if (invert) return positive ? 'danger' : 'success';
  return positive ? 'success' : 'danger';
}

export function fillTrendDays(
  trends: InspectBucketDayRow[],
  days: AdvancedStatsRange,
): InspectBucketDayRow[] {
  const map = new Map(trends.map((row) => [row.day, row]));
  return dayKeysForRange(days).map((day) => {
    const row = map.get(day);
    return row ?? { day, indexed: 0, excluded: 0, error: 0 };
  });
}

export function trendChartData(rows: InspectBucketDayRow[]) {
  return rows.map((row) => ({
    day: row.day,
    label: tehranDayLabel(row.day),
    indexed: row.indexed,
    excluded: row.excluded,
    error: row.error,
  }));
}

export function segmentIndexChartData(rows: SegmentIndexRow[]) {
  return rows.map((row) => ({
    segment: row.segment,
    label: decodeUrlForDisplay(row.segment),
    indexed: row.indexed,
    excluded: row.excluded,
    error: row.error,
    unknown: row.unknown,
  }));
}

export function segmentHttpChartData(rows: SegmentHttpRow[]) {
  return rows.map((row) => ({
    segment: row.segment,
    label: decodeUrlForDisplay(row.segment),
    http2xx: row.http2xx,
    http3xx: row.http3xx,
    http4xx: row.http4xx,
    http5xx: row.http5xx,
    unknown: row.unknown,
  }));
}
